export enum ClientSubdomainEditStep {
    INFO = 'INFO',
    KEYS = 'KEYS',
}